import { FaCircleNotch } from "react-icons/fa";
import { MdOutlineAdd } from "react-icons/md";



export function CustomButton ({ waiting, invitationLink, onClick, buttonText, buttonColor = 1 }) {
    return (
      <button
      disabled = {buttonColor === 2 ? true : false}
        type="submit"
        onClick={onClick}
        className={`text-bg3 ${
          invitationLink ? "hidden" : "block"
        } flex flex-row justify-center ml-[-4%] items-center text-center my-5 text-[18px] font-bold  px-3 rounded-2xl h-[60px] ${buttonColor === 2 ? "bg-gray-500" : "bg-primary"} w-[95%]  md:w-[67%] lg:w-[61%] gap-2`}
      >
        {waiting ? (
          <FaCircleNotch className="text-primary2 animate-spin text-3xl" />
        ) : (
          buttonText === `Request Permission ${buttonColor}` ? null : (
          <span className="text-[30px] text-white text-center w-8 h-8 flex items-center justify-center rounded-full border-2 border-white ">
            <MdOutlineAdd />
          </span>
        )
        )}
        <p className="ml-2">
          {waiting ? "Please wait..." : buttonText}
        </p>
      </button>
    );
  };
  